import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import { Loader2 } from "lucide-react";
import Select from "react-select";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  SelectSearch,
  TagInput,
} from "../../../../../../component/form/form-layout";
import XCloseIcon from "../../../../../../component/icons/x-close";
import LeftSidePopupLayout from "../../../../../../component/popup/modal-layout";
import { useApiCall } from "../../../../../../component/custom-hooks/api-call";
import InnerLoader from "../../../../../../component/ui/loader/inner-loader";

// const MultiValueInput = ({ values = [], onChange }) => {
//   const [input, setInput] = useState("");

//   const addValue = () => {
//     if (!input.trim()) return;
//     onChange([...values, input.trim()]);
//     setInput("");
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") {
//       e.preventDefault();
//       addValue();
//     }
//   };

//   const removeValue = (index) => {
//     const updated = values.filter((_, i) => i !== index);
//     onChange(updated);
//   };

//   return (
//     <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
//       {/* Input field with centered plus icon */}
//       <div style={{ position: "relative" }}>
//         <input
//           type="text"
//           value={input}
//           onChange={(e) => setInput(e.target.value)}
//           onKeyDown={handleKeyDown}
//           placeholder="Add value"
//           style={{
//             width: "100%",
//             padding: "6px 32px 6px 8px", // right padding for plus
//             borderRadius: "6px",
//             border: "1px solid #ccc",
//             fontSize: "0.95rem",
//           }}
//         />
//         <span
//           onClick={addValue}
//           style={{
//             position: "absolute",
//             right: 6,
//             top: "50%",
//             transform: "translateY(-50%)", // vertically center
//             cursor: "pointer",
//             fontWeight: "bold",
//             fontSize: "1.2rem",
//             color: "#007bff",
//           }}
//         >
//           +
//         </span>
//       </div>

//       {/* Display added values below input */}
//       <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 4 }}>
//         {values?.map((val, index) => (
//           <div
//             key={index}
//             style={{
//               backgroundColor: "#e0f7fa",
//               padding: "4px 8px",
//               borderRadius: "12px",
//               display: "flex",
//               alignItems: "center",
//               gap: 4,
//               fontSize: "0.9rem",
//             }}
//           >
//             {val}
//             <span
//               style={{ cursor: "pointer", fontWeight: "bold" }}
//               onClick={() => removeValue(index)}
//             >
//               ×
//             </span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

const AddAgent = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  agentData = {},
  brands = [],
  teams = [],
  users = [],
}) => {
  const apiCall = useApiCall();

  // DEFAULT DATA SET...
  useEffect(() => {
    if (agentData?.userid) {
      getAgentData(agentData?.userid);
      // formik.setFieldValue("name", agentData?.name);
      // formik.setFieldValue("email", agentData?.email);
      // formik.setFieldValue("phone", agentData?.phone);
      // formik.setFieldValue("usertype", agentData?.usertype);
      // formik.setFieldValue("country", agentData?.country);
      // formik.setFieldValue("state", agentData?.state);
      // formik.setFieldValue("city", agentData?.city);
      // formik.setFieldValue("team_id", agentData?.team_info?.team_id);
      // formik.setFieldValue(
      //   "brand_id",
      //   Array.isArray(agentData?.agent_brands)
      //     ? agentData?.agent_brands.map((brand) => brand.brandsid)
      //     : []
      // );
    }
  }, []);

  // location lists + loading
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [loadingCountry, setLoadingCountry] = useState(false);
  const [loadingState, setLoadingState] = useState(false);
  const [loadingCity, setLoadingCity] = useState(false);

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);

  // fetch countries
  const getCountries = async () => {
    try {
      setLoadingCountry(true);
      const res = await apiCall({
        method: "get",
        url: "location/get-countries",
      });
      setCountryList(res?.data || []);
    } catch (err) {
      console.warn("Country fetch error:", err);
    } finally {
      setLoadingCountry(false);
    }
  };

  const getStates = async (countryId) => {
    if (!countryId) return;
    try {
      setLoadingState(true);
      const res = await apiCall({
        method: "get",
        url: `location/get-states-by-country/${countryId}`,
      });
      setStateList(res?.data || []);
      setCityList([]);
    } catch (err) {
      console.warn("State fetch error:", err);
    } finally {
      setLoadingState(false);
    }
  };

  const getCities = async (stateId) => {
    if (!stateId) return;
    try {
      setLoadingCity(true);
      const res = await apiCall({
        method: "get",
        url: `location/get-cities-by-state/${stateId}`,
      });
      setCityList(res?.data || []);
    } catch (err) {
      console.warn("City fetch error:", err);
    } finally {
      setLoadingCity(false);
    }
  };

  // initial load countries
  useEffect(() => {
    getCountries();
  }, []);

  // --- Auto load states/cities when initial data exists ---
  useEffect(() => {
    // once countries list available and formik? has a ?country name, pick corresponding country id and load states
    if (countryList.length && formik?.values?.country) {
      const matched = countryList.find(
        (c) => c.country_name === formik?.values?.country
      );
      if (matched) {
        setSelectedCountry(matched.id);
        getStates(matched.id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryList]);

  useEffect(() => {
    // when stateList arrives and formik? has st?ate, find and load cities
    if (stateList.length && formik?.values?.state) {
      const matched = stateList.find((s) => s.name === formik?.values?.state);
      if (matched) {
        setSelectedState(matched.id);
        getCities(matched.id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateList]);

  // helpers to map options
  const countryOptions = countryList.map((c) => ({
    value: c.id,
    label: c.country_name,
  }));
  const stateOptions = stateList.map((s) => ({ value: s.id, label: s.name }));
  const cityOptions = cityList.map((ct) => ({ value: ct.id, label: ct.name }));

  // select styles (same as you used)
  const selectStyles = {
    control: (base, s) => ({
      ...base,
      minHeight: "35px",
      height: "auto",
      borderRadius: "5px",
      border: "1px solid #DFDFDF",
      backgroundColor: s.isDisabled ? "#f0f0f0" : "#FFF",
      boxShadow: "none",
      "&:hover": { borderColor: "#DFDFDF" },
      fontSize: "13px",
      lineHeight: "1.2",
      fontWeight: 500,
      color: "#1E1E1E",
      padding: "0 14px",
      cursor: s.isDisabled ? "not-allowed" : "normal",
    }),
    valueContainer: (base) => ({ ...base, height: "auto", padding: "0 0px 0" }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      fontSize: "14px",
      fontWeight: 500,
    }),
    singleValue: (base) => ({ ...base, fontSize: "14px", fontWeight: 500 }),
    placeholder: (base) => ({
      ...base,
      fontSize: "14px",
      fontWeight: 500,
      color: "#717680",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 99999 }),
    menu: (base) => ({
      ...base,
      marginTop: "2px",
      borderRadius: "5px",
      border: "1px solid #DFDFDF",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    }),
    option: (base, s) => ({
      ...base,
      fontSize: "14px",
      fontWeight: 500,
      color: s.isSelected ? "#FFF" : "#1E1E1E",
      backgroundColor: s.isSelected
        ? "#3b82f6"
        : s.isFocused
        ? "#F3F4F6"
        : "#FFF",
      padding: "8px 14px",
      cursor: "pointer",
    }),
    indicatorContainer: (base) => ({ ...base, padding: 0 }),
    dropdownIndicator: (base) => ({ ...base, padding: 0 }),
  };

  const teamsOptions = teams?.map((tm) => ({
    value: tm?.id,
    label: tm?.team_name + ` (${tm?.ttype})`,
  }));
  const usersOptions = users?.map((tm) => ({
    value: tm?.usertypeid,
    label: tm?.usertype,
  }));
  const brandsOptions = brands?.map((tm) => ({
    value: tm?.brandsid,
    label: tm?.brandname,
  }));

  const validationSchema = yup.object({
    name: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    email: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    phone: yup
      .string()
      .required("Phone number is required")
      .matches(/^\+?[0-9\s\-\(\)]+$/, "Invalid phone number format"),
    usertype: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    country: yup.string("This Field is Required").nullable(),
    state: yup.string("This Field is Required").nullable(),
    city: yup.string("This Field is Required").nullable(),
    brand_id: yup
      .array()
      .of(yup.string())
      .min(1, "This Field is Required")
      .required("This Field is Required"),
    team_id: yup
      .array()
      .of(yup.string())
      .min(1, "This Field is Required")
      .required("This Field is Required"),
    specialization: yup
      .array()
      .of(yup.string().trim())
      .min(1, "At least one tag is required")
      .required("At least one tag is required"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      usertype: "",
      country: "",
      state: "",
      city: "",
      brand_id: "",
      team_id: "",
      specialization: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      let data = {
        name: values.name,
        email: values.email,
        phone: values.phone,
        usertype: values.usertype,
        country: values.country,
        state: values.state,
        city: values.city,
        brand_id: values.brand_id.map((id) => Number(id)),
        team_id: values.team_id.map((id) => Number(id)),
        specialization: Array.isArray(values.specialization)
          ? values.specialization.join(",")
          : values.specialization,
      };

      console.log("Form data", data);

      try {
        let apiRes = await apiCall({
          method: "post",
          url: agentData?.userid
            ? `users/update-agent/${agentData?.userid}`
            : `users/add-agent`,
          data: data,
        });
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
        onClose();
      } catch (error) {
        console.log("Error", error);
        onError(
          error?.response.data?.respMsg ||
            error?.response.data?.responseMessage ||
            error?.response.data?.message ||
            "Some Thing Went Wrong"
        );
      }
    },
  });

  const [updateLoading, setUpdateLoading] = useState(false);
  const getAgentData = async (id) => {
    setUpdateLoading(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-edit-settings/${id}`,
      });

      let newAgentData = res?.data;

      formik.setFieldValue("name", newAgentData?.name);
      formik.setFieldValue("email", newAgentData?.email);
      formik.setFieldValue("phone", newAgentData?.phone);
      formik.setFieldValue("usertype", newAgentData?.usertype);
      formik.setFieldValue("country", newAgentData?.country);
      formik.setFieldValue("state", newAgentData?.state);
      formik.setFieldValue("city", newAgentData?.city);
      formik.setFieldValue("specialization", newAgentData?.specialization);
      // formik.setFieldValue("team_id", newAgentData?.team_info?.team_id);
      formik.setFieldValue(
        "brand_id",
        Array.isArray(newAgentData?.brands)
          ? newAgentData?.brands.map((brand) => brand)
          : []
      );
      formik.setFieldValue(
        "team_id",
        Array.isArray(newAgentData?.teams)
          ? newAgentData?.teams.map((team) => team)
          : []
      );
     
    } catch (error) {
    } finally {
      setUpdateLoading(false);
    }
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>{agentData?.userid ? "Update" : "Add"} Agent</h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          {updateLoading ? (
            <div className="flex justify-center items-center !h-full w-full">
              <InnerLoader />
            </div>
          ) : (
            <FormArea>
              {/* Name */}
              <FeildWraper>
                <FormLabel required>Name</FormLabel>
                <input
                  type="text"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  placeholder="name"
                />
                {formik.touched.name && formik.errors.name && (
                  <FeildError>{formik.errors.name}</FeildError>
                )}
              </FeildWraper>

              {/* Email */}
              <FeildWraper>
                <FormLabel required>Email</FormLabel>
                <input
                  type="text"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  placeholder="email"
                />
                {formik.touched.email && formik.errors.email && (
                  <FeildError>{formik.errors.email}</FeildError>
                )}
              </FeildWraper>

              {/* Phone */}
              <FeildWraper>
                <FormLabel required>Phone</FormLabel>
                <input
                  type="tel"
                  name="phone"
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                  placeholder="Phone"
                />
                {formik.touched.phone && formik.errors.phone && (
                  <FeildError>{formik.errors.phone}</FeildError>
                )}
              </FeildWraper>

              {/* User Type */}
              <FeildWraper>
                <FormLabel required>User Type</FormLabel>

                <Select
                  name="usertype"
                  className="text-sm"
                  classNamePrefix="react-select"
                  options={usersOptions}
                  components={{
                    IndicatorSeparator: () => null,
                    LoadingIndicator: () => null,
                  }}
                  value={usersOptions?.find(
                    (option) => option.value == formik?.values?.usertype
                  )}
                  onChange={(selectedOption) => {
                    formik.setFieldValue(
                      "usertype",
                      selectedOption?.value || ""
                    );
                  }}
                  filterOption={(option, inputValue) =>
                    option?.label
                      .toLowerCase()
                      .includes(inputValue?.toLowerCase())
                  }
                  placeholder="Search or select Brands..."
                  isClearable
                  menuPlacement="auto"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "35px",
                      height: "auto",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                      boxShadow: state.isFocused ? "none" : "none",
                      "&:hover": { borderColor: "#DFDFDF" },
                      fontSize: "13px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      padding: "0 14px",
                      cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "auto",
                      padding: "0 0px 0",
                    }),
                    input: (base) => ({
                      ...base,
                      margin: 0,
                      padding: 0,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      height: "auto",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#717680",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999,
                    }),
                    menu: (base) => ({
                      ...base,
                      marginTop: "2px",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }),
                    option: (base, state) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: state.isSelected ? "#FFF" : "#1E1E1E",
                      backgroundColor: state.isSelected
                        ? "#3b82f6"
                        : state.isFocused
                        ? "#F3F4F6"
                        : "#FFF",
                      padding: "8px 14px",
                      cursor: "pointer",
                    }),
                    indicatorContainer: (base) => ({
                      ...base,
                      padding: 0,
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      padding: 0,
                    }),
                  }}
                />
                {formik.touched.usertype && formik.errors.usertype && (
                  <FeildError>{formik.errors.usertype}</FeildError>
                )}
              </FeildWraper>

              {/* Brand ID */}
              <FeildWraper>
                <FormLabel required>Brand</FormLabel>

                <Select
                  name="brand_id"
                  className="text-sm"
                  classNamePrefix="react-select"
                  options={brandsOptions}
                  isMulti
                  components={{
                    IndicatorSeparator: () => null,
                    LoadingIndicator: () => null,
                  }}
                  // value={brandsOptions?.find(
                  //   (option) => option.value === formik.values.brand_id
                  // )}
                  value={brandsOptions?.filter((option) =>
                    Array.isArray(formik.values.brand_id)
                      ? formik.values.brand_id.includes(option.value)
                      : false
                  )}
                  // onChange={(selectedOption) => {
                  //   formik.setFieldValue(
                  //     "brand_id",
                  //     selectedOption?.value || ""
                  //   );
                  // }}
                  filterOption={(option, inputValue) =>
                    option.label
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  }
                  onChange={(selectedOptions) => {
                    const ids = selectedOptions?.map((opt) => opt.value);
                    formik.setFieldValue("brand_id", ids);
                  }}
                  placeholder="Search or select Brands..."
                  isClearable
                  menuPlacement="auto"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "35px",
                      height: "auto",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                      boxShadow: state.isFocused ? "none" : "none",
                      "&:hover": { borderColor: "#DFDFDF" },
                      fontSize: "13px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      padding: "0 14px",
                      cursor: state.isDisabled ? "not-allowed" : "normal",
                      margin: 0,
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "auto",
                      padding: 0,
                      margin: 0,
                      flexWrap: "wrap",
                      gap: "2px",
                    }),
                    multiValue: (base) => ({
                      ...base,
                      backgroundColor: "#E5E7EB",
                      borderRadius: "3px",
                      padding: "2px 6px",
                    }),
                    multiValueLabel: (base) => ({
                      ...base,
                      margin: 0,
                      padding: 0,
                      fontSize: "13px",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      height: "auto",
                    }),
                    multiValueRemove: (base) => ({
                      ...base,
                      color: "#666",
                      ":hover": {
                        backgroundColor: "#D1D5DB",
                        color: "#000",
                      },
                    }),
                    option: (base, state) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: state.isSelected ? "#FFF" : "#1E1E1E",
                      backgroundColor: state.isSelected
                        ? "#3b82f6"
                        : state.isFocused
                        ? "#F3F4F6"
                        : "#FFF",
                      padding: "8px 14px",
                      cursor: "pointer",
                    }),
                  }}
                />
                {formik.touched.brand_id && formik.errors.brand_id && (
                  <FeildError>{formik.errors.brand_id}</FeildError>
                )}
              </FeildWraper>

              {/* Team ID*/}
              <FeildWraper>
                <FormLabel required>Team</FormLabel>

                <Select
                  name="team_id"
                  className="text-sm"
                  classNamePrefix="react-select"
                  options={teamsOptions}
                  isMulti
                  components={{
                    IndicatorSeparator: () => null,
                    LoadingIndicator: () => null,
                  }}
                  value={teamsOptions?.filter((option) =>
                    Array.isArray(formik.values.team_id)
                      ? formik.values.team_id.includes(option.value)
                      : false
                  )}
                  onChange={(selectedOptions) => {
                    const ids = selectedOptions?.map((opt) => opt.value);
                    formik.setFieldValue("team_id", ids);
                  }}
                  filterOption={(option, inputValue) =>
                    option.label
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  }
                  placeholder="Search or select Brands..."
                  isClearable
                  menuPlacement="auto"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "35px",
                      height: "auto",
                      borderRadius: "5px",
                      border: "1px solid #DFDFDF",
                      backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                      boxShadow: state.isFocused ? "none" : "none",
                      "&:hover": { borderColor: "#DFDFDF" },
                      fontSize: "13px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      padding: "0 14px",
                      cursor: state.isDisabled ? "not-allowed" : "normal",
                      margin: 0,
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "auto",
                      padding: 0,
                      margin: 0,
                      flexWrap: "wrap",
                      gap: "2px",
                    }),
                    multiValue: (base) => ({
                      ...base,
                      backgroundColor: "#E5E7EB",
                      borderRadius: "3px",
                      padding: "2px 6px",
                    }),
                    multiValueLabel: (base) => ({
                      ...base,
                      margin: 0,
                      padding: 0,
                      fontSize: "13px",
                      fontWeight: 500,
                      color: "#1E1E1E",
                      height: "auto",
                    }),
                    multiValueRemove: (base) => ({
                      ...base,
                      color: "#666",
                      ":hover": {
                        backgroundColor: "#D1D5DB",
                        color: "#000",
                      },
                    }),
                    option: (base, state) => ({
                      ...base,
                      fontSize: "14px",
                      lineHeight: "1.2",
                      fontWeight: 500,
                      color: state.isSelected ? "#FFF" : "#1E1E1E",
                      backgroundColor: state.isSelected
                        ? "#3b82f6"
                        : state.isFocused
                        ? "#F3F4F6"
                        : "#FFF",
                      padding: "8px 14px",
                      cursor: "pointer",
                    }),
                  }}
                />
                {/* <SelectSearch
                  name="team_id"
                  placeholder="- Select Team -"
                  onChange={(selectedOptions) => {
                    const ids = selectedOptions?.map((opt) => opt.value);
                    formik.setFieldValue("team_id", ids);
                  }}
                  value={teamsOptions?.filter((option) =>
                    Array.isArray(formik.values.team_id)
                      ? formik.values.team_id.includes(option.value)
                      : false
                  )}
                  options={teamsOptions}
                  // menuPosition="fixed"
                  multiple={true}
                /> */}
                {formik.touched.team_id && formik.errors.team_id && (
                  <FeildError>{formik.errors.team_id}</FeildError>
                )}
              </FeildWraper>

              {/* specialization */}
              <FeildWraper>
                <FormLabel required>Specialization</FormLabel>
                <TagInput
                  value={formik.values.specialization}
                  placeholder="Press enter to create a tag"
                  onChange={(val) => {
                    formik.setFieldTouched("specialization", true);
                    formik.setFieldValue("specialization", val, true);
                  }}
                />

                {formik.touched.specialization &&
                formik.errors.specialization ? (
                  <FeildError>{formik.errors.specialization}</FeildError>
                ) : (
                  null
                  // <FeildError className="!text-[#3b82f6]">
                  //   Note: Press enter to create a tag
                  // </FeildError>
                )}
              </FeildWraper>

              {/* Country */}
              <FeildWraper>
                <FormLabel required>Country</FormLabel>
                <Select
                  className="text-sm"
                  classNamePrefix="react-select"
                  value={
                    countryOptions.find(
                      (opt) => opt.label === formik?.values?.country
                    ) || null
                  }
                  onChange={(option) => {
                    if (!option?.value) return;
                    formik?.setFieldValue("country", option.label);
                    formik?.setFieldValue("state", "");
                    formik?.setFieldValue("city", "");
                    setSelectedCountry(option.value);
                    setSelectedState(null);
                    getStates(option.value);
                  }}
                  options={countryOptions}
                  isLoading={loadingCountry}
                  isClearable
                  placeholder="Select country..."
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  components={{
                    IndicatorSeparator: () => null,
                    LoadingIndicator: () => (
                      <div className="flex items-center pr-2">
                        <Loader2 className="w-4 h-4 text-blue-600 animate-spin" />
                      </div>
                    ),
                  }}
                  styles={selectStyles}
                />
                {formik.touched.country && formik.errors.country && (
                  <FeildError>{formik.errors.country}</FeildError>
                )}
              </FeildWraper>

              {/* State */}
              <FeildWraper>
                <FormLabel required>State</FormLabel>
                <Select
                  className="text-sm"
                  classNamePrefix="react-select"
                  value={
                    stateOptions.find(
                      (opt) => opt.label === formik?.values?.state
                    ) || null
                  }
                  onChange={(option) => {
                    formik?.setFieldValue("state", option?.label || "");
                    formik?.setFieldValue("city", "");
                    setSelectedState(option?.value);
                    getCities(option?.value);
                  }}
                  options={stateOptions}
                  isLoading={loadingState}
                  isDisabled={!selectedCountry}
                  isClearable
                  placeholder="Select state..."
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  components={{
                    IndicatorSeparator: () => null,
                    LoadingIndicator: () => (
                      <div className="flex items-center pr-2">
                        <Loader2 className="w-4 h-4 text-blue-600 animate-spin" />
                      </div>
                    ),
                  }}
                  styles={selectStyles}
                />
                {formik.touched.state && formik.errors.state && (
                  <FeildError>{formik.errors.state}</FeildError>
                )}
              </FeildWraper>

              {/* City */}
              <FeildWraper>
                <FormLabel required>City</FormLabel>
                <Select
                  className="text-sm"
                  classNamePrefix="react-select"
                  value={
                    cityOptions.find(
                      (opt) => opt.label === formik?.values?.city
                    ) || null
                  }
                  onChange={(option) =>
                    formik?.setFieldValue("city", option?.label || "")
                  }
                  options={cityOptions}
                  isLoading={loadingCity}
                  isDisabled={!selectedState}
                  isClearable
                  placeholder="Select city..."
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  components={{
                    IndicatorSeparator: () => null,
                    LoadingIndicator: () => (
                      <div className="flex items-center pr-2">
                        <Loader2 className="w-4 h-4 text-blue-600 animate-spin" />
                      </div>
                    ),
                  }}
                  styles={selectStyles}
                />
                {formik.touched.city && formik.errors.city && (
                  <FeildError>{formik.errors.city}</FeildError>
                )}
              </FeildWraper>
            </FormArea>
          )}
          {/* <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} h-full pt-3`}>
              </div>
            </div>
          </div> */}
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {agentData?.userid ? "Update" : "Add"} Agent
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default AddAgent;
